import _axios from "../plugins/axios"
import { useEffect, useState } from "react"
import { generatePath, Link, useHistory } from "react-router-dom"
import { ActionSection, Row, Section, Table } from "../common/components"
import { API_URL, DAY_MAP } from "../common/constant"
import ROUTES from "../common/routes"
import { Patient, Reservation } from "../common/types"
import { getFormattedDate } from "../common/utils"

interface Props {
  patient: Patient | null
}

export default function MyReservationList(props: Props) {
  const history = useHistory()
  const { patient } = props
  const [reservations, setReservations] = useState<Reservation[]>([])

  useEffect(() => {
    if (!patient) {
      history.replace(ROUTES.home)
      return
    }

    ;(async function getMyReservations() {
      const res = await _axios.post(API_URL.myReservations,{
        patientId: patient.id,
        date: getFormattedDate(new Date()),
      })

      setReservations(res.data.result)
    })()
  }, [history, patient])

  return (
    <main style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "16px" }}>
      <ActionSection>
        <Link to={ROUTES.scheduleList}>預約掛號</Link>
        <Link to={ROUTES.home}>重新登入</Link>
      </ActionSection>

      <Section>
        <Row>使用者:{patient?.name}</Row>
        <Row style={{ textAlign: "center" }}>您目前的預約</Row>
        <Table>
          <thead>
            <tr>
              <th>日期</th>
              <th>科別</th>
              <th>醫生</th>
              <th>診次</th>
              <th>預約號</th>
              <th>查詢&取消</th>
            </tr>
          </thead>
          <tbody>
            {reservations.length === 0 && (
              <tr>
                <td style={{ background: "#EEEEEE", textAlign: "center" }} colSpan={6}>
                  您目前沒有任何預約
                </td>
              </tr>
            )}
            {reservations.map((r) => (
              <tr key={r.regReservationId}>
                <td>
                  {r.date}({DAY_MAP[new Date(r.date).getDay()]})
                </td>
                <td>{r.refDivisionName || '骨科'}</td>

                <td>{r.doctorName}</td>

                <td>
                  {r.refShift}
                  {r.hixClinicRoom}
                </td>

                <td>{r.viewNo}</td>

                <td>
                  <Link to={generatePath(ROUTES.reservationDetail, { id: r.regReservationId }) + "?review=true"}>
                    請點我
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Section>
    </main>
  )
}
